import { createContext, useContext, useEffect, useRef, useState } from "react";
import { api } from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=guest, obj=user
  const [checked, setChecked] = useState(false);
  const initRef = useRef(false);

  useEffect(() => {
    if (initRef.current) return;
    initRef.current = true;
    // CRITICAL: if returning from Emergent OAuth callback, skip /me — AuthCallback handles it
    if (typeof window !== "undefined" && window.location.hash && window.location.hash.includes("session_id=")) {
      setChecked(true);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(false))
      .finally(() => setChecked(true));
  }, []);

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {}
    setUser(false);
  };
  const setUserDirect = (u) => setUser(u);

  return (
    <AuthContext.Provider value={{ user, checked, logout, setUserDirect }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
